import AtendimentosNoMes from '../pages/AtendimentosNoMes/AtendimentosNoMes';
import AtendimentosNoMesPorEquipe from '../pages/AtendimentosNoMes/AtendimentosNoMesPorEquipe';
import AtendimentosNoMesDetalhar from '../pages/AtendimentosNoMes/AtendimentosNoMesDetalhar';
import AtendimentosNoMesProfissional from '../pages/AtendimentosNoMes/AtendimentosNoMesProfissional';

export default [
      {
         path: '/atendimentos-no-mes',
         component: AtendimentosNoMes 
      },
      {
         path: '/atendimentos-no-mes/equipe',
         component: AtendimentosNoMesPorEquipe
      },
      {
         path: '/atendimentos-no-mes/detalhar/:nu_cpf/:co_cbo',
         name: 'AtendimentosNoMesDetalhar',
         component: AtendimentosNoMesDetalhar
      },
      {
         path: '/atendimentos-no-mes/profissional',
         component: AtendimentosNoMesProfissional
      }
]